/** @format */

import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import { Fragment, lazy, Suspense } from "react";
import Loader from "./components/Loader";
import Styles from "./App.module.css";
import Sidebar from "./pages/Sidebar";

const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const Services = lazy(() => import("./pages/Services"));
const Projects = lazy(() => import("./pages/Projects"));

function App() {
  return (
    <div className={Styles.app}>
      <header className={Styles.navbar}>
        <Layout />
      </header>
      <Sidebar />
      <main className={Styles.content}>
        <Fragment>
          <div className={Styles.extraMargin}></div>
          <Suspense fallback={<Loader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/services" element={<Services />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </Fragment>
      </main>
    </div>
  );
}

export default App;
